import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const Email = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M20.39 4.52A3.32 3.32 0 0 0 18.6 4H5.24c-.57 0-1.09.15-1.56.4l8.25 6.59 8.46-6.46v-.01Z" />
      <Path d="m21.52 5.68-9.11 6.96c-.14.11-.31.16-.49.16s-.35-.06-.5-.17L2.45 5.46a3.41 3.41 0 0 0-.61 1.94v9.2c0 1.88 1.52 3.4 3.4 3.4H18.6c1.88 0 3.4-1.52 3.4-3.4V7.4c0-.63-.18-1.21-.48-1.72Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Email
